module.exports = new __parcel__URL__("Fix Bottom right.635459ac.svg").toString();